import { PackageCodesPPlus } from '@tn/foundation/entities/account/constants/packages';
import type { FullUser } from '@tn/foundation/graphql/__generated/resolvers-types';
import { SUBSCRIBER_STATUSES } from '@tn/foundation/utils/constants/userStatus';

// Unlike the shared isLCPSubscriber, this also matches a single-package (Essential-only) user.
export const isEssentialSubscriber = (user: FullUser | null | undefined): boolean =>
    SUBSCRIBER_STATUSES.includes(user?.userStatus?.description ?? '') &&
    user?.cbsPackageInfo?.[0]?.packageCode === PackageCodesPPlus.ESSENTIAL;

export const getLocalPlaybackMvpdId = (user: FullUser | null | undefined): string =>
    isEssentialSubscriber(user) ? 'pplusLCP' : 'AllAccess';
